<div class="info-chip">
  <p>{{info()}}</p>
</div>
